// extracted by mini-css-extract-plugin
export default {"imageWrapper":"DE-z","hovered":"EE-z","hoverImage":"FE-z","mainImage":"GE-z","imageNoBackground":"HE-z","fullSizeImage":"IE-z"};